import { AuthState } from "@okta/okta-auth-js";
import { Server } from "../../Shared/Util/Server";

export function fetchResponses(pageNumber: number, itemsPerPage: number, sortOrder: string, auth: AuthState, orderBy?: string): Promise<Api.IResponseListResponse | null> {
  let url = `/v1/response?pageNumber=${pageNumber}&resultsPerPage=${itemsPerPage}`;

  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }

  return Server.get<Api.IResponseListResponse>(url, auth);
}

export function fetchResponseVersions(responseId: string, auth: AuthState): Promise<Api.IHistoricalResponseListViewModel | null> {
  return Server.get<Api.IHistoricalResponseListViewModel>(`/response/${responseId}/versions`, auth);
}
